import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerStack: {
            direction: {base: 'column', lg: 'row'},
            alignItems: {base: 'flex-start', lg: 'center'},
            justifyContent: {base: 'flex-start', lg: 'space-between'},
        },
        deleteIcon: {w: remCalc(16), h: remCalc(16), verticalAlign: 'middle'},
    },
    parts: ['outerStack', 'deleteIcon'],
}
